export default __webpack_public_path__ + "static/media/logoWhite.d25c3c4f.png";